import { render, staticRenderFns } from "./CategorySearchItem.vue?vue&type=template&id=16da31db&"
import script from "./CategorySearchItem.vue?vue&type=script&lang=js&"
export * from "./CategorySearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/joelstorm/Sites/hanken-sse-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16da31db', component.options)
    } else {
      api.reload('16da31db', component.options)
    }
    module.hot.accept("./CategorySearchItem.vue?vue&type=template&id=16da31db&", function () {
      api.rerender('16da31db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/CategorySearchItem.vue"
export default component.exports